// extracted by mini-css-extract-plugin
export default {"title":"Projects_title__tBYLF","section":"Projects_section__j0PU9","container":"Projects_container__-9eVi"};